<div [style.width]="'calc(100% - 3px)'" [style.height]="'100%'">
  <apiz-grid-headless
    [pagination]="true"
    [paginationPageCountOption]="10"
    [paginationPageCountOptions]="[10, 20, 30, 40, 50, 'AUTO']" />
</div>
